export default __webpack_public_path__ + "static/media/UC-Logo.e1552d8b.png";